import { Component, OnInit } from '@angular/core';
import { GoogleObj } from '../models/GoogleObj';
import { GoogletranslateService } from "../service/googletranslate.service";
@Component({
  selector: 'app-root',
  templateUrl: './sample.component.html',
  styleUrls: ['./sample.component.css']
})
export class SampleComponent implements OnInit {
  private translateBtn: any;
  value:any
googleAddObj:GoogleObj
  constructor(private google: GoogletranslateService) { 
    this.googleAddObj=new GoogleObj()
  }

  ngOnInit(): void {
    this.translateBtn = document.getElementById("translateBtn");

  }
  send() {
    var data=`<p>So what exactly is going on????In our ts file,</p> we;
    <b>Created an instance of the GoogleTranslateService </b>
    created a send() method. In our method, we have googleObj variable which is an object that contains the query parameters,(our input string is ‘hello’, and the language to translate to is Spanish ‘es’). We also subscribe to the translate method in our GoogleTranslateService when the button is clicked, passing googleObj as an argument and print out the response. In this case, ‘Hola’ is printed.
    But we want the user to select their own language. We’ll modify the app.component.ts and app.component.html files."
    `;
    this.googleAddObj.q=[data]
    this.googleAddObj.target="hi"

   // this.translateBtn.disabled = true;
    this.google.translate(this.googleAddObj).subscribe( (res: any) => {
  //  this.translateBtn.disabled = false;
    this.value=res.data.translations[0].translatedText
    console.log(this.value)
    },
    err => {
    console.log(err);
    }
  )
}
}
